module.exports = __webpack_public_path__ + "assets/ic-milk-token.206d6555.svg";